var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-col"},[_vm._l((_vm.items),function(item){return [_c('o-menu-item',{key:item.path,attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }